export default __webpack_public_path__ + "static/media/15-min.226d3d71.jpg";